import {Pressable, StyleSheet, Text, View} from "react-native";
import {Color} from "@/lib/styles";
import Icon from "@/lib/components/Icon";

type Props = {
    selected: boolean,
    onPress: () => any,
    title: string,
    description: string,
    checkbox: boolean,
}

export default function Radio({selected, title, description, checkbox, onPress}: Props) {
    return (
        <Pressable style={[styles.container, {borderColor: selected ? Color.BorderStrong : Color.Faded}]}
                   onPress={() => onPress()}
        >
            <View style={styles.title}>
                {!selected && !checkbox && <Icon kind={"radio"}/>}
                {selected && !checkbox && <Icon kind={"radioSelected"} color={Color.Yellow}/>}
                {!selected && checkbox && <Icon kind={"checkbox"}/>}
                {selected && checkbox && <Icon kind={"checkboxChecked"} color={Color.Yellow}/>}
                <Text style={styles.titleText} selectable={false}>{title}</Text>
            </View>
            <Text style={styles.descriptionText} selectable={false}>{description}</Text>
        </Pressable>
    )
}

export const styles = StyleSheet.create({
    container: {
        width: "100%",
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: Color.Yellow,
        borderRadius: 7,
        padding: 12,
        gap: 6,
        fontSize: 16,
        marginLeft: "auto",
        marginRight: "auto",
    },
    title: {
        flexDirection: "row",
        justifyContent: "flex-start",
        alignItems: "center",
        height: 24,
        gap: 8,
    },
    titleText: {
        fontSize: 16,
        fontWeight: 500,
        color: Color.PrimaryText,
    },
    descriptionText: {
        fontSize: 16,
        lineHeight: 20,
        color: Color.SecondaryText,
    },
})